module.exports = __webpack_public_path__ + "static/media/CTLI_14-111w.cc232f8b.png";